'use client'

import { Spinner } from '@graftcode/design-system'

import styles from './ShareFeedback.module.scss'

export function ShareFeedbackSending() {
  return (
    <div className={styles.sending} aria-busy="true" aria-live="polite">
      <Spinner size={48} />
    </div>
  )
}
